import { render } from "./Product02.vue?vue&type=template&id=de9be1a2"
import script from "./Product02.vue?vue&type=script&lang=js"
export * from "./Product02.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__